import type { IconSvgObject } from './types';

const GavelIcon: IconSvgObject = [
  ["path", { d: "M14 2L7 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 9L14 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8.5 8L15 14.5M19.5 10L13 3.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M11.5 11.5L2 21", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M22 22H11", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "4" }],
  ["path", { d: "M20 21.5C20 20.5681 20 20.1022 19.8478 19.7346C19.6448 19.2446 19.2554 18.8552 18.7654 18.6522C18.3978 18.5 17.9319 18.5 17 18.5H16C15.0681 18.5 14.6022 18.5 14.2346 18.6522C13.7446 18.8552 13.3552 19.2446 13.1522 19.7346C13 20.1022 13 20.5681 13 21.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "5" }]
];

export default GavelIcon;
